import appInfo from './controller/appInfo';
import Equalizer from './module/equalizer';
import Controller from './controller/controller';
import {pageInfo, layerInfo} from './page/pagesInfo';
$(document).ready(function () {
if ( typeof window.CustomEvent === "function" ) return false;
function CustomEvent ( event, params ) {
    params = params || { bubbles: false, cancelable: false, detail: undefined };
    let evt = document.createEvent( 'CustomEvent' );
    evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
    return evt;
}
CustomEvent.prototype = window.Event.prototype;
window.CustomEvent = CustomEvent;
});

$(document).ready(function () {
    let controller;
    controller =  new Controller(pageInfo, layerInfo);

    new nc.promokit.Preloader({
        'game': 'aion',
        'delay': 100,
        'image': [
            '/promo/aion/history/2018/181128_color/img/common/logo.png',
            '/promo/aion/history/2018/181128_color/img/intro/intro_bg.jpg',
            '/promo/aion/history/2018/181128_color/img/intro/intro_title.png',
            '/promo/aion/history/2018/181128_color/img/intro/intro_txt_1.png',
            '/promo/aion/history/2018/181128_color/img/intro/intro_btn_play.png',
            '/promo/aion/history/2018/181128_color/img/gate/gate_bg.jpg',
            '/promo/aion/history/2018/181128_color/img/gate/gate_txt.png',
            '/promo/aion/history/2018/181128_color/img/gate/gate_card_on_1.png',
            '/promo/aion/history/2018/181128_color/img/gate/gate_card_on_2.png',
            '/promo/aion/history/2018/181128_color/img/gate/gate_card_on_3.png',
            '/promo/aion/history/2018/181128_color/img/gate/gate_card_on_4.png',
            '/promo/aion/history/2018/181128_color/img/gate/gate_card_on_5.png',
            '/promo/aion/history/2018/181128_color/img/gate/gate_card_on_6.png',
            '/promo/aion/history/2018/181128_color/img/gate/gate_card_on_7.png',
            '/promo/aion/history/2018/181128_color/img/gate/gate_card_on_8.png',
            '/promo/aion/history/2018/181128_color/img/gate/gate_card_on_9.png',
            '/promo/aion/history/2018/181128_color/img/page1/page1_bg.jpg',
            '/promo/aion/history/2018/181128_color/img/page1/page1_btn.png',
            '/promo/aion/history/2018/181128_color/img/page1/page1_btn_play.png',
            '/promo/aion/history/2018/181128_color/img/page1/page1_charactor.png',
            '/promo/aion/history/2018/181128_color/img/page1/page1_charactor_ef1.png',
            '/promo/aion/history/2018/181128_color/img/page1/page1_charactor_ef2.png',
            '/promo/aion/history/2018/181128_color/img/page1/page1_simbol.png',
            '/promo/aion/history/2018/181128_color/img/page1/page1_skill_bg.png',
            '/promo/aion/history/2018/181128_color/img/page1/page1_skill_inner.png',
            '/promo/aion/history/2018/181128_color/img/page1/page1_skill_overBg.png',
            '/promo/aion/history/2018/181128_color/img/page2/page2_1_bg.jpg',
            '/promo/aion/history/2018/181128_color/img/page2/page2_2_bg.jpg',
            '/promo/aion/history/2018/181128_color/img/page2/page2_3_bg.jpg',
            '/promo/aion/history/2018/181128_color/img/page2/page2_1_txt.png',
            '/promo/aion/history/2018/181128_color/img/page2/page2_2_txt.png',
            '/promo/aion/history/2018/181128_color/img/page2/page2_3_txt.png',
            '/promo/aion/history/2018/181128_color/img/page2/page2_tab_off.png',
            '/promo/aion/history/2018/181128_color/img/page2/page2_tab_on.png',
            '/promo/aion/history/2018/181128_color/img/page3/page3_bg.jpg',
            '/promo/aion/history/2018/181128_color/img/page3/page3_img1.jpg',
            '/promo/aion/history/2018/181128_color/img/page3/page3_img2.jpg',
            '/promo/aion/history/2018/181128_color/img/page3/page3_img3.jpg',
            '/promo/aion/history/2018/181128_color/img/page3/page3_img4.jpg',
            '/promo/aion/history/2018/181128_color/img/page3/page3_icon.png',
            '/promo/aion/history/2018/181128_color/img/page4/page4_bg.jpg',
            '/promo/aion/history/2018/181128_color/img/page4/page4_character.png',
            '/promo/aion/history/2018/181128_color/img/page4/page4_character_ef.png',
            '/promo/aion/history/2018/181128_color/img/page4/page4_title.png',
            '/promo/aion/history/2018/181128_color/img/page5/page5_bg.jpg',
            '/promo/aion/history/2018/181128_color/img/page5/page5_img1.jpg',
            '/promo/aion/history/2018/181128_color/img/page5/page5_img2.jpg',
            '/promo/aion/history/2018/181128_color/img/page5/page5_img3.jpg',
            '/promo/aion/history/2018/181128_color/img/page5/page5_img4.jpg',
            '/promo/aion/history/2018/181128_color/img/page6/page6_bg.jpg',
            '/promo/aion/history/2018/181128_color/img/page6/page6_img1.jpg',
            '/promo/aion/history/2018/181128_color/img/page6/page6_img2.jpg',
            '/promo/aion/history/2018/181128_color/img/page6/page6_img3.jpg',
            '/promo/aion/history/2018/181128_color/img/page6/page6_img4.jpg',
            '/promo/aion/history/2018/181128_color/img/page7/page7_bg.jpg',
            '/promo/aion/history/2018/181128_color/img/page7/page7_img1.jpg',
            '/promo/aion/history/2018/181128_color/img/page7/page7_img2.jpg',
            '/promo/aion/history/2018/181128_color/img/page7/page7_img3.jpg',
            '/promo/aion/history/2018/181128_color/img/page7/page7_img4.jpg',
            '/promo/aion/history/2018/181128_color/img/page8/page8_bg.jpg',
            '/promo/aion/history/2018/181128_color/img/page8/page9_pve1.jpg',
            '/promo/aion/history/2018/181128_color/img/page8/page9_pve2.jpg',
            '/promo/aion/history/2018/181128_color/img/page8/page9_pve3.jpg',
            '/promo/aion/history/2018/181128_color/img/page8/page9_pvp1.jpg',
            '/promo/aion/history/2018/181128_color/img/page8/page9_pvp2.jpg',
            '/promo/aion/history/2018/181128_color/img/page8/page9_pvp3.jpg',
            '/promo/aion/history/2018/181128_color/img/page8/page8_character_left.png',
            '/promo/aion/history/2018/181128_color/img/page8/page8_character_right.png',
            '/promo/aion/history/2018/181128_color/img/page8/page8_ico_play.png',
            '/promo/aion/history/2018/181128_color/img/page8/page8_ico_play_left.png',
            '/promo/aion/history/2018/181128_color/img/page8/page8_ico_play_right.png',
            '/promo/aion/history/2018/181128_color/img/page9/page9_bg1.jpg',
            '/promo/aion/history/2018/181128_color/img/page9/page9_bg2.jpg',
            '/promo/aion/history/2018/181128_color/img/page9/page9_bg3.jpg',
            '/promo/aion/history/2018/181128_color/img/page9/page9_bg1_ch.png',
            '/promo/aion/history/2018/181128_color/img/page9/page9_bg2_ch.png',
            '/promo/aion/history/2018/181128_color/img/page9/page9_bg3_ch.png'

        ],
        'video':[
            // 'http://vodfile.ncsoft.co.kr/ncvod/plaync/Aion/7update/AION_Web_BG.mp4',
            // 'http://vodfile.ncsoft.co.kr/ncvod/plaync/Aion/7update/Skill_Ver2_SP.mp4',
            // 'http://vodfile.ncsoft.co.kr/ncvod/plaync/Aion/7update/Skill_Ver3_SP.mp4',
            // 'http://vodfile.ncsoft.co.kr/ncvod/plaync/Aion/7update/Skill_Ver1_SP.mp4',
            // 'http://vodfile.ncsoft.co.kr/ncvod/plaync/Aion/7update/E01.mp4',
            // 'http://vodfile.ncsoft.co.kr/ncvod/plaync/Aion/7update/E02.mp4',
            // 'http://vodfile.ncsoft.co.kr/ncvod/plaync/Aion/7update/E03.mp4',


        ],
        'youtbue':[],
    });

    $(document).on('preloadend', function(){
            $('.loding_bg').remove();
            controller.init('intro');

    });

});


// WEBPACK FOOTER //
// ./src/js/index.js